import Page from "../common/page";
import * as newsListItem from '/src/ejs/component/component-news-item-list.ejs';
import {HtmlUtil} from "../utils/HtmlUtil";

export default class PageNewsView extends Page {
    setPage() {
        const asideNavigationEl = this.el.querySelector('.section-title .list-holder');
        const contentNavigationEl = this.el.querySelector('.sec-1 .list-holder');

        this.setViewContent(this.data.page.data.news.view);
        this.setNavigation(
            asideNavigationEl,
            this.data.page.data.news.prev,
            this.data.page.data.news.next,
            this.data.page.data.news.link
        );

        this.setNavigation(
            contentNavigationEl,
            this.data.page.data.news.prev,
            this.data.page.data.news.next,
            this.data.page.data.news.link
        );

        this.el.querySelector('.section-title .component-title-holder p').innerHTML = this.data.page.data.news.view.date;
        this.el.querySelector('.sec-1 .component-title-holder p').innerHTML = this.data.page.data.news.view.date;
    }

    setViewContent(data) {
        this.el.querySelector('.sec-1 .txt-holder h3').innerHTML = data.title;
        this.el.querySelector('.sec-1 .txt-holder span').innerHTML = data.date;
        this.el.querySelector('.sec-1 .news-body-holder .img-holder img').src = data.img;

        data.content = "<div>" + data.content;
        data.content += "</div>";
        this.el.querySelector('.sec-1 .news-body-holder').appendChild(
            HtmlUtil.getStrElement(data.content)
        );
    }

    setNavigation(el, prevData, nextData, link) {
        el.querySelector('.list a').href = link;
        if (prevData !== null) {
            el.querySelector('.prev a').href = prevData.link;
            el.querySelector('.prev img').src = prevData.img;
            el.querySelector('.prev p').innerHTML = prevData.title;
        } else {
            el.querySelector('.prev img').src = '/static/img/blank.png';
            el.querySelector('.prev').style.display = 'none';
        }
        if (nextData !== null) {
            el.querySelector('.next a').href = nextData.link;
            el.querySelector('.next img').src = nextData.img;
            el.querySelector('.next p').innerHTML = nextData.title;
        } else {
            el.querySelector('.next img').src = '/static/img/blank.png';
            el.querySelector('.next').style.display = 'none';
        }
    }
}
